import type { ModeColor } from "@src/types/factory-dashboard";
import type { ChenHsongMachineOverviewDefinition } from "@src/types/factory-dashboard-chen-hsong";

const GREY: ModeColor = {
  outline: "rgb(138, 143, 152)",
  background: "rgba(138, 143, 152, 0.1)",
};
const YELLOW: ModeColor = {
  outline: "rgb(245, 179, 1)",
  background: "rgba(245, 179, 1, 0.1)",
};
const GREEN: ModeColor = {
  outline: "rgb(32, 178, 107)",
  background: "rgba(32, 178, 107, 0.1)",
};

// EUROMAP77 mapping from provided screenshot
export const modeMappingChenHsong = {
  0: { label: "modules.machineOverviewContainer.mode.other", color: GREY },
  1: { label: "modules.machineOverviewContainer.mode.automatic", color: GREEN },
  2: {
    label: "modules.machineOverviewContainer.mode.semiAutomatic",
    color: GREEN,
  },
  3: { label: "modules.machineOverviewContainer.mode.manual", color: YELLOW },
  4: { label: "modules.machineOverviewContainer.mode.setup", color: YELLOW },
  5: {
    label: "modules.machineOverviewContainer.mode.sleep",
    color: GREY,
  },
};

export const machinesChenHsongSouthAmerica: ChenHsongMachineOverviewDefinition[] =
  [
    {
      sourceId: "17ec4944-fdc6-8dc6-ace9-4415d8329b02",
      nodes: {
        machineMode: "ns=1;s=injectionMode",
        job: "ns=1;s=moldName",
        cycleTime: "ns=1;s=machineCycleTime",
        nominalParts: "ns=1;s=orderQuantity",
        jobBadPartsCounter: "",
        jobGoodPartsCounter: "ns=1;s=totalInjectCount",
      },
      fallbackValues: {
        jobBadPartsCounter: 0,
      },
      modeMapping: modeMappingChenHsong,
    },
    {
      sourceId: "d695d071-e4b1-84b1-856f-b5e6e3d2ae02",
      nodes: {
        machineMode: "ns=6;s=::AsGlobalPV:RECIPE.RO.eAutoMode",
        job: "ns=6;s=::AsGlobalPV:IMMdata.ActDescJob",
        cycleTime: "ns=6;s=::AsGlobalPV:IMMdata.ActTimCyc",
        nominalParts: "ns=6;s=::AsGlobalPV:IMMdata.SetCntCyc",
        jobBadPartsCounter: "ns=6;s=::AsGlobalPV:IMMdata.ActCntCycRej",
        jobGoodPartsCounter: "ns=6;s=::AsGlobalPV:IMMdata.ActCntCyc",
      },
      modeMapping: modeMappingChenHsong,
    },
    {
      sourceId: "6d68e29a-6000-8000-9de8-e58901288002",
      nodes: {
        machineMode: "ns=6;s=::AsGlobalPV:RECIPE.RO.eAutoMode",
        job: "ns=6;s=::AsGlobalPV:IMMdata.ActDescJob",
        cycleTime: "ns=6;s=::AsGlobalPV:IMMdata.ActTimCyc",
        nominalParts: "ns=6;s=::AsGlobalPV:IMMdata.SetCntCyc",
        jobBadPartsCounter: "ns=6;s=::AsGlobalPV:IMMdata.ActCntCycRej",
        jobGoodPartsCounter: "ns=6;s=::AsGlobalPV:IMMdata.ActCntCyc",
      },
      modeMapping: modeMappingChenHsong,
    },
  ];
